export default "__VITE_ASSET__Cc2Vo0YX__"